export default __webpack_public_path__ + "static/media/946.6a4336be.gif";